/**
 * AI Presence Service
 * Tracks when users are actively using AI across all sessions
 */

import { ref, set, onValue, serverTimestamp } from 'firebase/database';
import { rtdb } from './firebase';

const AI_SESSION_PATH = 'sessions/global-canvas-v1';

/**
 * Set user's AI activity status
 */
export function setAIActive(userId, isActive, prompt = null) {
  if (!userId) return;

  const userRef = ref(rtdb, `${AI_SESSION_PATH}/${userId}/aiStatus`);
  
  if (isActive) {
    set(userRef, {
      aiActive: true,
      currentPrompt: prompt || 'Generating shapes...',
      startedAt: Date.now()
    });
  } else {
    set(userRef, {
      aiActive: false,
      currentPrompt: null,
      startedAt: null
    });
  }
}

/**
 * Subscribe to all users' AI activity
 */
export function subscribeToAIActivity(callback) {
  const sessionRef = ref(rtdb, AI_SESSION_PATH);
  
  const unsubscribe = onValue(sessionRef, (snapshot) => {
    const data = snapshot.val();
    if (!data) {
      callback([]);
      return;
    }

    // Extract AI activity for each user
    const aiActivity = [];
    Object.entries(data).forEach(([userId, userData]) => {
      if (userData.aiStatus?.aiActive) {
        aiActivity.push({
          userId,
          displayName: userData.displayName || 'Anonymous',
          cursorColor: userData.cursorColor || '#3b82f6',
          prompt: userData.aiStatus.currentPrompt,
          startedAt: userData.aiStatus.startedAt
        });
      }
    });

    callback(aiActivity);
  });

  return unsubscribe;
}

/**
 * Cleanup AI status on disconnect
 */
export function setupAIDisconnectCleanup(userId) {
  if (!userId) return;

  const userRef = ref(rtdb, `${AI_SESSION_PATH}/${userId}/aiStatus`);
  
  // Note: onDisconnect would be set up in the main presence initialization
  // This is a helper to manually clear status
  return () => {
    set(userRef, {
      aiActive: false,
      currentPrompt: null,
      startedAt: null
    });
  };
}


